import React, { useEffect, useState } from 'react';
import Modal from '@/components/Modal';
import SwaggerLoader from '@/components/SwaggerLoader';
import SelectBox from '@/components/SelectBox';
import useConfig from '@/hooks/useConfig';
import { useLocation } from 'react-router-dom';
import QueryString from 'qs';
import { getSpecUrl } from '@/specUrls';

export interface MainProps {
  type: string;
  defaultUrl: string; // 스웨거 url
  domainListUrl: string; // 스웨거 도메인 리스트 호출 url
  docsUrl: string; // 스웨거 문서 호출 url
  defaultDomain?: string; //기본으로 보여줄 스웨거 도메인
}

function Swagger({ type, defaultUrl, domainListUrl, docsUrl, defaultDomain = 'admin' }: MainProps) {
  const [name, setName] = useState(defaultDomain);
  const [modalState, setModalState] = useState(false);
  const [specUrls, setSpecUrls] = useState([{ name: '', url: '' }]);
  const [specUrl, setSpecUrl] = useState('');
  const [currHostName, setCurrHostName] = useState('');
  const getConfig = useConfig({ type, defaultUrl, domainListUrl });
  const query = useLocation().search;

  const getUrl = async (): Promise<string> => {
    const queryData = QueryString.parse(query, { ignoreQueryPrefix: true });
    const primaryName = (queryData['url.primaryName'] as string).slice(0, -1);
    setName(primaryName);
    return getSpecUrl(specUrls, primaryName);
  };

  const setSpecUrlData = async () => {
    const urls = await getConfig(domainListUrl);
    setSpecUrls(urls);
  };
  useEffect(() => {
    setSpecUrlData();
  }, [domainListUrl]);

  const init = async () => {
    const url = !query ? docsUrl : await getUrl();
    setCurrHostName(window.location.host);
    setSpecUrl(url);
  };

  const handleModalState = () => {
    setModalState(state => !state);
  };

  useEffect(() => {
    init();
  }, [query, specUrls, docsUrl]);

  return (
    <>
      <SelectBox
        data={specUrls}
        name={name}
        setName={setName}
        defaultUrl={defaultUrl}
        handleModalState={handleModalState}
      />
      {specUrl && <SwaggerLoader url={specUrl} />}
      <Modal host={currHostName} isVisible={modalState} setModalState={setModalState} />
    </>
  );
}

export default Swagger;
